import { createFileRoute } from '@tanstack/react-router';
import { EventsListBody } from '@/components/events/EventsListBody';
import {
  type EventsListFormat,
  type EventsListTab,
  type EventsSearchInput,
} from '@/lib/queries/events';

function parseTab(v: unknown): EventsListTab | undefined {
  return v === 'mine' || v === 'circle' || v === 'network' || v === 'platform'
    ? v
    : undefined;
}
function parseFormat(v: unknown): EventsListFormat | 'any' | undefined {
  if (v === 'in_person' || v === 'virtual' || v === 'any') return v;
  return undefined;
}
function pickStr(v: unknown): string | undefined {
  return typeof v === 'string' && v.length > 0 ? v : undefined;
}

export const Route = createFileRoute('/_authed/events/')({
  validateSearch: (raw: Record<string, unknown>): EventsSearchInput => ({
    ...(pickStr(raw.q) ? { q: pickStr(raw.q) as string } : {}),
    ...(parseTab(raw.tab) !== undefined
      ? { tab: parseTab(raw.tab) as EventsListTab }
      : {}),
    ...(pickStr(raw.network) ? { network: pickStr(raw.network) as string } : {}),
    ...(parseFormat(raw.format) !== undefined
      ? { format: parseFormat(raw.format) as EventsListFormat | 'any' }
      : {}),
    ...(pickStr(raw.from) ? { from: pickStr(raw.from) as string } : {}),
    ...(pickStr(raw.to) ? { to: pickStr(raw.to) as string } : {}),
  }),
  component: EventsListPage,
});

function EventsListPage() {
  return <EventsListBody />;
}
